import styled from 'styled-components'
import { DatePicker as AntDatePicker } from 'antd'

export const DatePicker = styled(AntDatePicker)`
  border-radius: 0.5rem;
`
